"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
function ServiceShowcaseConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="174266" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 max-w-7xl mx-auto px-6">
        {[...Array(6)].map((_, i) => <Card key={i} data-index={i} className="bg-card border-none overflow-hidden shadow-xl">
            <Skeleton className="aspect-[4/5] w-full bg-secondary/10" />
            <CardContent className="pt-8 pb-4 px-8 flex flex-col items-center gap-4">
              <Skeleton className="h-8 w-3/4 rounded-lg bg-secondary/10" />
              <Skeleton className="h-4 w-1/2 rounded-lg bg-secondary/10" />
            </CardContent>
            <CardFooter className="pb-8 px-8 flex justify-center">
              <Skeleton className="h-12 w-40 rounded-lg bg-secondary/10" />
            </CardFooter>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-foreground/60 font-sans">
        <p>Unable to load performance packages at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12 text-foreground/60 font-sans">
        <p>No packages currently available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 max-w-7xl mx-auto px-6 relative z-10">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="bg-card border-none overflow-hidden shadow-xl group transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl flex flex-col">
          <div className="relative overflow-hidden aspect-[4/5]">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/service_default.png"} alt={post.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent opacity-90 mix-blend-normal transition-opacity duration-500 group-hover:opacity-70"></div>
          </div>
          
          <CardContent className="pt-8 pb-4 px-8 flex flex-col items-center text-center grow z-10 -mt-20">
            <h3 className="font-serif text-2xl md:text-3xl mb-3 text-card-foreground leading-tight drop-shadow-sm">
              {post.title}
            </h3>
            <div className="font-sans text-xs md:text-sm tracking-widest uppercase text-card-foreground/80 flex items-center gap-3 justify-center flex-wrap">
              {post.customFields?.price && <span className="font-medium text-secondary">${post.customFields.price}</span>}
              {post.customFields?.price && post.customFields?.duration_minutes && <span className="w-1 h-1 rounded-lg bg-secondary/50"></span>}
              {post.customFields?.duration_minutes && <span>{post.customFields.duration_minutes} MINS</span>}
            </div>
          </CardContent>
          
          <CardFooter className="pb-10 px-8 flex justify-center z-10">
            <Button asChild className="border-2 border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-primary-foreground transition-all duration-300 px-8 py-6 h-auto text-xs md:text-sm tracking-wider uppercase font-sans font-medium">
              <Link to="#inquiry-form">
                Request a Quote
              </Link>
            </Button>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function ServiceShowcase() {
  const wp_query = new WP_Query({
    per_page: 6,
    orderby: "date",
    order: "desc"
  });
  return;
}